import { ReturnMetricEnum } from '../enums/return-metric-enum';

export const RETURN_METRIC_LABELS: Record<ReturnMetricEnum, string> = {
    [ReturnMetricEnum.SimpleReturn]: 'SR',
    [ReturnMetricEnum.TimeWeightedReturn]: 'TWR',
    [ReturnMetricEnum.MoneyWeightedReturn]: 'MWR',
};

export const RETURN_METRIC_SUFFIXES: Record<ReturnMetricEnum, string> = {
    [ReturnMetricEnum.SimpleReturn]: '',
    [ReturnMetricEnum.TimeWeightedReturn]: '_twr',
    [ReturnMetricEnum.MoneyWeightedReturn]: '_mwr',
};

export const RETURN_METRIC_STORAGE_KEYS = {
    unrealizedProfit: 'dashboardUnrealizedProfitMetric',
    profitChart: 'dashboardProfitChartMetric',
} as const;

export const getSeriesIdForMetric = (baseId: string, metric: ReturnMetricEnum): string => {
    return `${baseId}${RETURN_METRIC_SUFFIXES[metric]}`;
};

export const getBaseSeriesId = (seriesId: string): string => {
    return seriesId.replace(/_(twr|mwr)$/, '');
};

export const getStoredReturnMetric = (key: string, fallback: ReturnMetricEnum): ReturnMetricEnum => {
    if (typeof window === 'undefined') {
        return fallback;
    }

    const storedMetric = window.localStorage.getItem(key);

    if (storedMetric === ReturnMetricEnum.SimpleReturn) {
        return ReturnMetricEnum.SimpleReturn;
    }

    if (storedMetric === ReturnMetricEnum.TimeWeightedReturn) {
        return ReturnMetricEnum.TimeWeightedReturn;
    }

    if (storedMetric === ReturnMetricEnum.MoneyWeightedReturn) {
        return ReturnMetricEnum.MoneyWeightedReturn;
    }

    return fallback;
};
